import { render, staticRenderFns } from "./ConnectedClients.vue?vue&type=template&id=08d2676c&scoped=true&"
import script from "./ConnectedClients.vue?vue&type=script&lang=js&"
export * from "./ConnectedClients.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedClients.vue?vue&type=style&index=0&id=08d2676c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2676c",
  null
  
)

export default component.exports